import styled from "styled-components";

export const MainWrapper = styled.div`
  display: flex;
  flex-grow: 4;
  width: 60%;
  flex-shrink: 1;
  flex-direction: column;
  height: 100vh;
  /* background-color: blue; */
  flex-basis: 0;
`;
